import React from 'react';
import { observer } from 'mobx-react';
import { MakeButtonContainer } from './MakeButtonContainer';
import DownloadButton from './DownloadButton';
import CollaboratorsContainer from './CollaboratorsContainer';
import DiscussButton from './DiscussButton';

import { FeaturesWrapper } from './headerFileFeatures.styled';

const HeaderFileFeatures = observer(() => {
  return (
    <FeaturesWrapper>
      <DownloadButton />
      <CollaboratorsContainer />
      <DiscussButton />
      <MakeButtonContainer />
    </FeaturesWrapper>
  );
});

export default HeaderFileFeatures;
